/**
 * Mock Interview Click Tracker Utility
 * Tracks free clicks per button type and enforces payment after 1 free click
 */

export const BUTTON_TYPES = {
  ASK_QUESTION: 'ask_question',
  PRACTICE: 'practice',
  RECORD: 'record',
  START_INTERVIEW: 'start_interview',
  SUBMIT: 'submit'
};

export const initializeClickTracker = (userId) => {
  const trackerKey = `mock_interview_clicks_${userId}`;
  const existing = localStorage.getItem(trackerKey);
  
  if (!existing) {
    const tracker = {
      createdAt: new Date().toISOString(),
      globalClicks: 0,
      clicks: {
        [BUTTON_TYPES.ASK_QUESTION]: 0,
        [BUTTON_TYPES.PRACTICE]: 0,
        [BUTTON_TYPES.RECORD]: 0,
        [BUTTON_TYPES.START_INTERVIEW]: 0,
        [BUTTON_TYPES.SUBMIT]: 0,
      }
    };
    localStorage.setItem(trackerKey, JSON.stringify(tracker));
    return tracker;
  }
  
  return JSON.parse(existing);
};

export const recordButtonClick = (userId, buttonType) => {
  const tracker = initializeClickTracker(userId);
  
  if (!tracker.clicks[buttonType]) {
    tracker.clicks[buttonType] = 0;
  }
  
  tracker.clicks[buttonType] += 1;
  tracker.globalClicks = (tracker.globalClicks || 0) + 1;
  localStorage.setItem(`mock_interview_clicks_${userId}`, JSON.stringify(tracker));
  
  return tracker.globalClicks;
};

export const checkClickStatus = (userId, buttonType) => {
  const tracker = initializeClickTracker(userId);
  const typeClickCount = tracker.clicks[buttonType] || 0;
  
  return {
    clickCount: typeClickCount,
    isFreeClickAvailable: typeClickCount === 0,
    clicksUsed: typeClickCount,
    needsPayment: typeClickCount >= 1
  };
};

export const resetButtonClicks = (userId, buttonType) => {
  const tracker = initializeClickTracker(userId);
  tracker.clicks[buttonType] = 0;
  localStorage.setItem(`mock_interview_clicks_${userId}`, JSON.stringify(tracker));
  return tracker;
};

// After successful payment, unlock all clicks
export const unlockAllClicks = (userId) => {
  const trackerKey = `mock_interview_clicks_${userId}`;
  const tracker = initializeClickTracker(userId);
  
  // Mark as unlimited after payment
  tracker.isUnlimited = true;
  tracker.unlockedAt = new Date().toISOString();
  localStorage.setItem(trackerKey, JSON.stringify(tracker));
  
  return tracker;
};

export const hasUnlimitedClicks = (userId) => {
  const trackerKey = `mock_interview_clicks_${userId}`;
  const existing = localStorage.getItem(trackerKey);
  
  if (!existing) return false;
  
  const tracker = JSON.parse(existing);
  return tracker.isUnlimited === true;
};





